import React from "react";

interface Props extends React.DetailedHTMLProps<React.SVGProps<SVGSVGElement>, SVGSVGElement> {
	color: string | undefined;
}

const AutoSync = (props: Props) => {
	const { color, ...htmlProps } = props;

	return (
		<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24" fill={color} style={{ margin: "auto" }} {...htmlProps}>
			<path d="m437-398 227-226-57-57-170 170-85-85-56 56 141 142ZM40-120v-80h880v80H40Zm120-120q-33 0-56.5-23.5T80-320v-440q0-33 23.5-56.5T160-840h640q33 0 56.5 23.5T880-760v440q0 33-23.5 56.5T800-240H160Zm0-80h640v-440H160v440Zm0 0v-440 440Z" />
		</svg>
	);
};

export default AutoSync;
